import React, { PureComponent } from "react";

export default class FetchingMediasList extends PureComponent {
  render() {
    return (
      <div id="new-community-media-fetching" className="fetching-v2 grid-x">
        {[1, 2, 3, 4, 5, 6, 7, 8].map(el => (
          <div
            className="media-fetching cell small-12 medium-6 large-3"
            key={`media-fetching-${el}`}
          >
            <div className="gradiant" />
          </div>
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Community/NewCommunity/Fetching/FetchingMediasList.js